import * as React from 'react';

interface SwitchBtnProps {
  customClasses?: string ;
  value: boolean;
  fullCustom?: boolean;
  disabled?: boolean;
  labelStyle?: any;
  inputStyle?: any;
  spanlabelStyle?: any;
  spanHandleStyle?: any;
  onChangeEvent(value: boolean): void;
  isDestructureBtn?: boolean;
}

export class SwitchBtn  extends React.Component<SwitchBtnProps> {
  constructor(props: SwitchBtnProps) {
    super(props);
    this.changeCheck = this.changeCheck.bind(this);
  }

  changeCheck(event: React.ChangeEvent<HTMLInputElement>) {
      this._emitChanged(!this.props.value);
  }

  _emitChanged(value: boolean) {
    if (value !== this.props.value ) {
      this.props.onChangeEvent(value);
    }
  }

  render() {
    const styling : any  = {
      label: this.props.labelStyle || {},
      input: this.props.inputStyle || {},
      spanlabel: this.props.spanlabelStyle || {},
      spanHandle: this.props.spanHandleStyle || {},
    }
    const defaultClass = this.props.fullCustom ? '' : 'switchCustom';
    const customClasses = this.props.customClasses && typeof this.props.customClasses === "string" ? this.props.customClasses : '';
    return (
        <label className={defaultClass+ ' ' +customClasses} style={styling.label}>
          <input id={this.props.isDestructureBtn ? 'isDestructureBtn' : 'check-'} className={'switch-input'} disabled={this.props.disabled} checked={this.props.value} onChange={this.changeCheck} style={styling.input} type='checkbox'/><span className='switch-label'  style={styling.spanlabel} data-on='On' data-off='Off'></span><span  style={styling.spanHandle} className='switch-handle'></span>
        </label>
    );
  }
}
